/**
 * Generated runtime TestId mirror for frontend/src/pages/RelationshipSchema.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RelationshipSchemaTestIds = {
  btnCreateSchema: "btn-create-schema",
  btnCreateSchemaEmpty: "btn-create-schema-empty",
  btnDeactivate: "btn-deactivate",
  btnDialogCancel: "btn-dialog-cancel",
  btnDialogSave: "btn-dialog-save",
  colActions: "col-actions",
  colCardinality: "col-cardinality",
  colDisplay: "col-display",
  colFromType: "col-from-type",
  colRelationshipType: "col-relationship-type",
  colStatus: "col-status",
  colToType: "col-to-type",
  dialogTitle: "dialog-title",
  enforcementBanner: "enforcement-banner",
  enforcementChangeModeButton: "enforcement-change-mode-button",
  enforcementModeSelect: "enforcement-mode-select",
  enforcementModeText: "enforcement-mode-text",
  inputAliasNameFrom: "input-alias-name-from",
  inputAliasNameTo: "input-alias-name-to",
  inputFromSideLabel: "input-from-side-label",
  inputToSideLabel: "input-to-side-label",
  relationshipSchemaPage: "relationship-schema-page",
  runValidationButton: "run-validation-button",
  selectFromPartyType: "select-from-party-type",
  selectRelationshipType: "select-relationship-type",
  selectToPartyType: "select-to-party-type",
  switchEditActive: "switch-edit-active",
  switchFromSideDisplay: "switch-from-side-display",
  switchFromSideTree: "switch-from-side-tree",
  switchToSideDisplay: "switch-to-side-display",
  switchToSideTree: "switch-to-side-tree",
  violationBadgeCardinality: "violation-badge-cardinality",
  violationBadgeNoSchema: "violation-badge-no-schema",
  violationColCreatedAt: "violation-col-created-at",
  violationColDetail: "violation-col-detail",
  violationColFromType: "violation-col-from-type",
  violationColRelationshipType: "violation-col-relationship-type",
  violationColToType: "violation-col-to-type",
  violationColType: "violation-col-type",
  enforcementModeDescription: (selectedModeObj_code: string) => `enforcement-mode-description-${selectedModeObj_code}`,
  enforcementModeDescriptionPrefix: () => "enforcement-mode-description-" as TestIdPrefix,
  violationRowNoSchema: (v_violationId: string) => `violation-row-no-schema-${v_violationId}`,
  violationRowNoSchemaPrefix: () => "violation-row-no-schema-" as TestIdPrefix
} as const;
